import { styled, ThemeProps } from '@teko/ds-desktop';

export const NavigationButton = styled.div(
  ({ theme }: ThemeProps) => `
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
  min-width: 90px;
  padding: .365rem .75rem;
  font-size: 13px;
  position: relative;
  cursor: pointer;
  font-weight: 500;
  color: ${theme.colors.textSecondary};
  a {
    text-decoration: none;
    color: unset;
  }
  &:hover {
    color: ${theme.colors.primary500} !important;
    > :not(.noti) path {
      fill: ${theme.colors.primary500};
    }
    > .noti path{
      stroke: ${theme.colors.primary500};
    }
    .title, .text-left .title{
      color: ${theme.colors.primary500};
    }
    .text-left {
      text-align: left;
    }
  }
  `,
);
